import { Component, Input } from '@angular/core';

@Component({
  selector: 'brand-reviews',
  templateUrl: 'brand-reviews.html'
})
export class BrandReviewsComponent {

  @Input() reviewsTitle: string = `<h2 class="reviews_titleContent">SUCCESS STORIES</h2>`;
  @Input() varyingText: string = ''; //TOUC-924
  @Input() perReviewAddOn: string;
  @Input() star: string = 'https://cdn.gundrymd.com/images/prebiothrive/5starGreen.png';
  @Input() reviews: any[] = [
    {
      title: `<p>"Excellent Product"</p>`,
      author: `<p><span class="bold">Name:</span> Elsa</p>`,
      date: '',
      content: `<p>I feel so much better after taking both the Prebio-Thrive and the 24 strain Probiotic. I don't feel bloated, I am loving these products.</p>`,
      verified: true,
      stars: 1
    },
    {
      title: `<p>"Great Product"</p>`,
      author: `<span class="bold">Name:</span>Lori Vannice`,
      date: '',
      content: `<p>This is a great product. I have only been on it for a month, but I am seeing good results. Have had problems for ten years, and finally my stomach is not blowing up all the time. I love the product</p>`,
      verified: true,
      stars: 1
    },
    {
      title: `<p>"The Best Probiotics"</p>`,
      author: '<span class="bold">Name:</span>Marlene S. Stratton`',
      date: '',
      content: `<p>Since I have been taking the 24 hour Probiotics I feel so much better and I am feeling great. Thank you Dr. Gundry for making a beautiful pure product.</p>`,
      verified: true,
      stars: 1
    },
    {
      title: `<p>"Amazing"</p>`,
      author: '<span class="bold">Name:</span>Judy`',
      date: '',
      content: `<p>This is the best probiotic I have ever tried. It has really improved my digestion after a stomach infection, and now I have no issues.</p>`,
      verified: true,
      stars: 1
    },
    {
      title: `<p>"The Probiotic Did Solve My Issues"</p>`,
      author: '<span class="bold">Name:</span>Gina Jungles`',
      date: '',
      content: `<p>Best results comparing to others used.It's a happy family enjoying the benefits. Amazing knowledge behind this brand!!</p>`,
      verified: true,
      stars: 1
    }
  ];

  Arr = Array;


  constructor() { }

}
